<template>
  <svg :class="svgName">
    <use :xlink:href="xlinkName" />
  </svg>
</template>

<script>
export default {
  name: 'die',

  props: {
    // Multiplier on length of a frame (must be a whole number)
    frameLength: {
      type: Number,
      default: 1
    },

    // True if sixes should be highlighted in a different color
    highlightSix: {
      type: Boolean,
      default: false
    },

    // True if ones should be highlighted in a different color
    highlightOne: {
      type: Boolean,
      default: true
    },

    // True if all highlighting should be disabled, overriding other highlight options
    noHighlight: {
      type: Boolean,
      default: false
    },

    // True if the rolling animation should be played
    rolling: {
      type: Boolean,
      default: false
    },

    // The value shown on the die (between 1 and 6 inclusive)
    value: {
      type: Number,
      default: 1
    }
  },

  created () {
    this.animate()
    this.updateTimer()
  },

  updated () {
    this.updateTimer()
  },

  beforeDestroy () {
    clearInterval(this.timer)
  },

  data () {
    return {
      displayedValue: 1,
      nextFrameDelay: 0,
      timer: ''
    }
  },

  methods: {
    // Update the displayed value on the die.
    animate () {
      // If we're being delayed, count down the delay
      if (this.nextFrameDelay) {
        --this.nextFrameDelay
        return
      }

      // Advance to next frame
      this.$emit('onFrame')

      if (!this.rolling) this.displayedValue = this.value
      else this.displayedValue = 1 + Math.floor(Math.random() * Math.floor(6))

      this.nextFrameDelay = this.frameLength - 1
    },

    // Set/clear the timer interval
    updateTimer () {
      // Set timer if it should be on
      if (this.rolling && !this.timer) {
        this.timer = setInterval(this.animate, Math.random() * 20 + 40)
      }

      // Clear timer if it should be off
      if (!this.rolling && this.timer) {
        clearInterval(this.timer)
        this.timer = null
        this.displayedValue = this.value
      }
    }
  },

  computed: {
    // Name of the SVG class.
    svgName () {
      let color = 'secondary'

      // Rolling color
      if (this.rolling) {
        color = 'muted'
      }
      // Highlights disabled
      else if (this.noHighlight) {
        color = 'white'
      }
      // Hit/failure/miss colors
      else {
        if (this.displayedValue === 1 && this.highlightOne) color = 'danger'
        else if (this.displayedValue === 5) color = 'success'
        else if (this.displayedValue === 6) {
          if (this.highlightSix) color = 'warning'
          else color = 'success'
        }
      }

      return 'diecon text-' + color
    },

    // Name of the xlink class for the icon.
    xlinkName () {
      return '#diecon-' + this.displayedValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// die.vue?4a894f3d